import { orderBy } from 'lodash-es';
import { NotificationResult, INotification } from '@/types';



const initialState: NotificationResult = {
    totalCount: 0,
    notifications: [],
};

function mergeNotifications(
    existingNotifications: INotification[],
    notificationResult: NotificationResult
): NotificationResult {
    const notificationsById = new Map<number, INotification>();

    existingNotifications.forEach((n) => {
        notificationsById.set(n.id, n);
    });

    notificationResult.notifications.forEach((n) => {
        notificationsById.set(n.id, n);
    });

    return {
        totalCount: notificationResult.totalCount,
        notifications: orderBy(Array.from(notificationsById.values()), 'createDate', 'desc'),
    };
}

const notification = (state: NotificationResult = initialState, action) => {
    switch (action.type) {
        case 'NOTIFICATION::SET':
            return action.data;
        case 'NOTIFICATION::ADD':
            return mergeNotifications(state.notifications, action.data);
        case 'NOTIFICATION::ADD_MANY':
            return mergeNotifications(state.notifications, action.data);
        default:
            return state;
    }
};

export default notification;